<div class="logout-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div
                class="daxa-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
                [class.component-dark-theme]="themeService.isDark()"
            >
                <div class="title text-center">
                    <h3>
                        Dobro došli!
                    </h3>
                </div>
                <div class="admin text-center">
                    <div class="logo position-relative rounded-circle">
                        <img src="images/oda.gif" alt="logo">
                    </div>
                    <span class="d-block fw-medium">
                        Odjavljeni ste iz aplikacije
                    </span>
                </div>
                <a routerLink="/authentication" mat-button class="btn">
                    Prijavite se
                </a>
            </div>
        </div>
    </div>
</div>